export default __webpack_public_path__ + "/dist/images/fda-logo.4a29a89d2832062a7e475cc51cb92054.svg";